<template>
  <div v-if="showUploader">
    <div class="file-uploader" @click="triggerFileInput">
      <font-awesome-icon icon="fa-paperclip" />
    </div>
    <input
        type="file"
        ref="fileInput"
        :multiple="multiple"
        @change="handleFileInput"
        :accept="accepted"
        style="display: none;">
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useWidgetStore } from '@/store'

export default {
  name: 'FileUploader',
  data () {
    return {
      error: false,
      errorMessage: ''
    }
  },
  props: {
    showUploader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useWidgetStore, { fileLimitsConfig: 'fileLimits' }),
    multiple () {
      return this.fileLimits?.uploadMaxFiles
    },
    accepted () {
      return `.${this.fileLimits?.uploadFileTypes?.join(',.')}`
    },
    fileLimits () {
      return this.fileLimitsConfig && typeof this.fileLimitsConfig === 'string' ? JSON.parse(this.fileLimitsConfig) : this.fileLimitsConfig
    }
  },
  methods: {
    triggerFileInput () {
      this.$emit('click')
      this.$refs.fileInput.click()
    },
    // Define the function to handle file uploads
    handleFileInput (event) {
      const files = event.target.files
      const that = this
      // Loop through the files and encode them to base64
      const fileDataArray = []

      if (files.length === 0) {
        this.error = true
        this.errorMessage = this.$i18n.t('noFileSelected')
        this.$emit('error', this.errorMessage)
        console.log('No file selected.')
        return
      }
      // Check if the maximum number of files has been reached
      if (files.length + parseInt(this.fileLimits.usedUploadMaxFiles) + 1 > parseInt(this.fileLimits.uploadMaxFiles)) {
        // this.errorMessage = `Maximum number of ${this.fileLimits.uploadMaxFiles} files has been reached`
        this.errorMessage = this.$i18n.t('fileCouldNotBeSentValidationErr') + ' ' + files[0].name + ' ' + this.$i18n.t('maxFilesExceededValidationErr') + ' (' + this.fileLimits.uploadMaxFiles + ')'
        this.$emit('error', this.errorMessage)
        console.log(`Maximum number of ${this.fileLimits.maxUploadFiles} files has been reached`)
        return
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileType = this.getFileType(file.name)

        // Check if the file type is allowed
        if (!this.fileLimits.uploadFileTypes.includes(fileType)) {
          console.log(`File type ${fileType} is not allowed`)
          // this.errorMessage = `File type ${fileType} is not allowed. Only ${this.fileLimits.uploadFileTypes} files are allowed.`
          this.errorMessage = this.$i18n.t('fileCouldNotBeSentValidationErr') + ' ' + file.name + ' ' + this.$i18n.t('fileTypeNotAllowedValidationErr')
          this.$emit('error', this.errorMessage)

          break
        }

        // Check if the file size is within the allowed limit
        if (file.size > this.fileLimits.uploadMaxFileSize) {
          console.log(`File size exceeds the maximum allowed size of ${this.fileLimits.uploadMaxFileSize} bytes`)
          this.errorMessage = this.$i18n.t('fileCouldNotBeSentValidationErr') + ' ' + file.name + ' ' + this.$i18n.t('fileSizeExceededValidationErr') // setting static 2MB as requested by QA
          this.$emit('error', this.errorMessage)

          break
        }

        // Check if the file size is within the allowed limit
        if (files.length > this.fileLimits?.uploadMaxFiles) {
          console.log(`Upload max limit exceeds the maximum allowed files ${this.fileLimits?.uploadMaxFiles} files`)
          this.errorMessage = this.$i18n.t('uploadMaxLimitExceededValidationErr') + ' ' + this.fileLimits?.uploadMaxFiles + ' ' + this.$i18n.t('files')
          this.$emit('error', this.errorMessage)

          break
        }

        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          const fileData = {
            name: file.name,
            type: file.type,
            size: file.size,
            data: reader.result.split(',')[1]
          }
          fileDataArray.push(fileData)

          // Check if all files have been encoded
          if (fileDataArray.length === files.length) {
            // Upload the files
            that.$emit('upload', fileDataArray)
          }
        }
      }
    },
    // Define the function to get the file type from the file name
    getFileType (fileName) {
      const parts = fileName.split('.')
      return parts[parts.length - 1].toLowerCase()
    }
  }
}
</script>

<style scoped>
.file-uploader {
  display: inline-block;
  padding: 10px;
  cursor: pointer;
  margin-right: 3px;
  margin-top: 1px;

}
.material-icons {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 5px;
  color: #615d5d;
}
</style>
